import HtmlParser from 'html-react-parser';
import * as React from 'react';
import styled from 'styled-components';
import { NextStepButton, PreviousStepButton, SaveButtonsGroup } from '../../../containers/save-buttons/SaveButtonsGroup';
import ContentConstants from '../../../contentConstants';
import { SurveyStep } from '../../../models';
import { BodyCopyLink, InstructionsContainer, InstructionsText, InstructionsTitle } from '../../common/styles/globalStyles';

export const ContentContainer = styled.div`
	text-align: center;
	position: relative;
	margin-top: 125px;
	margin-bottom: 105px;
	@media (min-width: 0) and (max-width: 768px) {
		margin-top: 105px;
		margin-bottom: 85px;
	}
`;
ContentContainer.displayName = 'ContentContainer';

export interface INoQuestionsContentProps {
	Jump: (step: SurveyStep) => void;
}

export const NoQuestionsContent = ({ Jump: jumpToStep }: INoQuestionsContentProps) => {
	return (
		<>
			<ContentContainer>
				<InstructionsContainer>
					<InstructionsTitle>{ContentConstants.LOGIC_AND_LAYOUT.NO_QUESTIONS_TITLE}</InstructionsTitle>
					<InstructionsText>
						{HtmlParser(ContentConstants.LOGIC_AND_LAYOUT.NO_QUESTIONS_BODY_PART_ONE)}
						<BodyCopyLink onClick={() => jumpToStep(SurveyStep.Define)} role='button'>
							{ContentConstants.LOGIC_AND_LAYOUT.NO_QUESTIONS_HYPERLINK_TEXT}
						</BodyCopyLink>
						{ContentConstants.LOGIC_AND_LAYOUT.NO_QUESTIONS_BODY_PART_TWO}
					</InstructionsText>
				</InstructionsContainer>
			</ContentContainer>
			<SaveButtonsGroup>
				<PreviousStepButton />
				<NextStepButton />
			</SaveButtonsGroup>
		</>
	);
};
